import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core'
import { UserAdmin } from '../../../models/UserAdmin'
import { NgForm } from '@angular/forms'
import { UserService } from '../../../services/user.service'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { NotificationService } from '../../../services/notification.service'
import { AWSService } from '../../../services/aws.service'
import { getLoggedUser, setLoggedUser } from 'src/app/_helpers/LocalStorage'
import { ActivatedRoute } from '@angular/router'

@Component({
	selector: 'app-user-detail',
	templateUrl: './user-detail.component.html'
})
export class UserDetailComponent implements OnInit {
	@ViewChild('form') public form: NgForm
	@ViewChild('formPassword') public formPassword: NgForm
	public userAdmin: UserAdmin
	public open: boolean = false
	public currentPasswordModel: string
	public newPasswordModel: string
	public rePasswordModel: string
	public fileInput: any
	public ViewValidation: ViewValidation = new ViewValidation()

	@Output()
	public sessionUser: UserAdmin = getLoggedUser()

	constructor(
		public notificationService: NotificationService,
		private userService: UserService,
		private awsService: AWSService,
		private route: ActivatedRoute
	) {}

	public async ngOnInit(): Promise<void> {
		try {
			this.route.queryParams.subscribe(params => {
				const firstLogin = Boolean(params.changePassword)
				this.open = firstLogin
			  })

			this.notificationService.initLoading()
			this.getSessionUser()
			this.notificationService.stopLoading()
		} catch (err) {}
	}

	public getSessionUser(): void {
		this.sessionUser = getLoggedUser()
	}

	public fetchUser() {
		try {
			this.getSessionUser()
		} catch (err) {
			console.log(err)
		}
	}

	public telMask(tel: string): string {
		if (tel && tel.length < 15) {
			return '(00) 0000-00009'
		}

		return '(00) 00000-0000'
	}

	public async updateUserDetails(): Promise<void> {
		try {
			const file: any = this.fileInput
			const userUpdateObject: any = {
				name: this.sessionUser.name,
				email: this.sessionUser.email,
				cpf: this.sessionUser.cpf,
				tel: this.sessionUser.tel
			}

			if (file) {
				this.notificationService.initLoading()
				const data: any = await this.awsService.uploadToS3(file)
				userUpdateObject.media_url = data.Location
				this.notificationService.stopLoading()
			}

			const response: any = await this.userService
				.updatePersonalDetails(this.sessionUser._id, userUpdateObject)
				.toPromise()

			this.notificationService.notify(response.message, 200)

			setLoggedUser({...getLoggedUser(), media_url: userUpdateObject.media_url})
			this.fetchUser()

		} catch (err) {
			console.log(err)
		}
	}

	public async changePassword(): Promise<void> {
		try {
			const passwordObject: any = {
				email: this.sessionUser.email,
				currentPassword: this.currentPasswordModel,
				newPassword: this.newPasswordModel
			}
			const response: any = await this.userService.changePassword(passwordObject).toPromise()
			this.notificationService.notify(response.message, 200)
			this.closeModal()

			return
		} catch (err) {}
	}

	public handleSendAndReplace($event: any): void {
		this.readThis($event.target)
	}

	public readThis(inputValue: any): void {
		const file: File = inputValue.files[0]
		this.fileInput = file
		const myReader: FileReader = new FileReader()
		myReader.readAsDataURL(file)
		myReader.onloadend = e => {
			const base64: any = myReader.result
			this.sessionUser.media_url = base64
		}
	}

	public openModal(): void {
		this.formPassword.reset()
		this.open = true
		this.currentPasswordModel = ''
		this.newPasswordModel = ''
		this.rePasswordModel = ''
	}

	public closeModal(): void {
		this.formPassword.reset()
		this.open = false
		this.currentPasswordModel = ''
		this.newPasswordModel = ''
		this.rePasswordModel = ''
	}
}
